import React, { useEffect, useState } from "react";
import "../../css_files/Ticket/TicketPopup.css";
import CloseForm from "../Master/CloseForm";
import axios from "axios";
import getCookie from "../../api";
import { toast } from "react-toastify";
import AutoCompleteSearch from "../Master/AutoCompleteSearch";
import axiosInstance from "../../api";
import TicketParts from "./TicketParts";

function TicketPopup({
  setshowticketpopup,
  ticketId,
  refresh,
  setrefresh,
  setShowAssignedUsersEdit,
  setShowAssignedUsers,
  setTicketId,
}) {
  const [ticketData, setTicketData] = useState({
    SeriesId: ticketId,
    ServiceDetails: {
      ServiceType: "",
      Remarks: "",
      DueDate: "",
      ServiceDescription: "",
      FeedBack: "",
    },
    IsQuotationSent: false,
    IsOrderCreated: false,
    Status: "Open",
    SeriesId: ticketId,
  });

  const [showticketParts, setShowTicketParts] = useState(false);
  const [enquiry, setEnquiry] = useState();
  const [partsTicketData, setPartsTicketData] = useState([]);
  const [partsTicketLoading, setPartsTicketLoading] = useState(false);
  const [collapseparts, setcollapseparts] = useState([]);
  const [extraParts, setExtraParts] = useState(false);
  const [extraPartsInput, setExtraPartsInput] = useState([]);
  const [extraPartsIndex, setExtraPartsIndex] = useState(0);

  const [createPartsTicket, setCreatePartsTicket] = useState([]);
  const [allPartsTickets, setAllPartsTickets] = useState([]);
  const [partnames, setpartnames] = useState([]);
  const [filteredpartnames, setfilteredpartnames] = useState([]);
  const [ticketsStatus, setTicketsStatus] = useState([]);

  useEffect(() => {
    setTicketData(null);

    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Ticket/${encodeURIComponent(
          ticketId
        )}`
      )
      .then((res) => {
        setTicketData({
          ...ticketData,
          ServiceDetails: {
            ServiceType: res?.data?.serviceDetails?.serviceType,
            Remarks: res?.data?.serviceDetails?.remarks,
            DueDate: res?.data?.serviceDetails?.dueDate?.split("T")[0],
            ServiceDescription: res?.data?.serviceDetails?.serviceDescription,
            FeedBack: res?.data?.serviceDetails?.feedBack,
          },
          IsQuotationSent: res?.data?.isQuotationSent,
          IsOrderCreated: res?.data?.isOrderCreated,
          Status: res?.data?.status,
        });
        setEnquiry(res?.data?.newEnquiry);

        if (res?.data?.enquiryType === "Parts") {
          getTicketParts();
        }
      })
      .catch(console.log);
  }, [ticketId]);

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Ticket/GetAllTicketStatus`)
      .then((res) => {
        setTicketsStatus(res.data);
      })
      .catch(console.log);
  }, [ticketData]);

  function handleSubmit(e) {
    e.preventDefault();
    if (enquiry.enquiryType === "Parts") {
      axiosInstance
        .put(
          `${process.env.REACT_APP_API_URL}/api/PartsTicket/UpdatePartsTickets`,
          {
            TicketId: ticketId,
            partIds: [...createPartsTicket, ...extraPartsInput],
            EnquiryId: enquiry.seriesID,
            BoilerHead: enquiry.customerBoiler?.boiler?.head,
            BoilerSeries: enquiry.customerBoiler.boilerSeriess?.seriesCode,
          }
        )
        .then(() => {
          axiosInstance
            .put(`${process.env.REACT_APP_API_URL}/api/v1/Ticket`, ticketData)
            .then((res) => {
              toast.success(res.data, {
                position: "bottom-center",
                theme: "dark",
              });
              setshowticketpopup(false);
              setrefresh(!refresh);
            })
            .catch(console.log);
        })
        .catch(console.log);
    } else {
      axiosInstance
        .put(`${process.env.REACT_APP_API_URL}/api/v1/Ticket`, ticketData)
        .then((res) => {
          toast.success(res.data, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowticketpopup(false);
          setrefresh(!refresh);
        })
        .catch(console.log);
    }
  }

  function getTicketParts() {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/PartsTicket/${ticketId}`)
      .then((res) => {
        setAllPartsTickets(res.data);
      })
      .catch(console.log);
  }

  useEffect(() => {
    const allParts = partsTicketData.flatMap((item) =>
      item.parts.map((x) => x.id)
    );

    const extras = allPartsTickets
      .map((x) => x.part.id)
      .filter((part) => !allParts.includes(part));

    setExtraPartsInput(extras);
    setCreatePartsTicket(
      allPartsTickets
        .map((x) => x.part.id)
        .filter((part) => !extras.includes(part))
    );

    setExtraParts(extras.length > 0);
  }, [partsTicketData, allPartsTickets]);

  return (
    <section className="ticket-popup">
      {ticketData && (
        <form onSubmit={handleSubmit}>
          <h1>Ticket Details</h1>
          <p>
            <strong>Linked to Enquiry: </strong>
            {enquiry?.seriesID}
          </p>
          <blockquote>
            <label>Ticket Id</label>
            <input type="text" disabled value={ticketData.SeriesId} />
          </blockquote>
          {ticketData.ServiceDetails && (
            <>
              <blockquote>
                <label>
                  Service Type{" "}
                  <sup>
                    <i
                      class="fa-solid fa-asterisk"
                      style={{ color: "red" }}
                    ></i>
                  </sup>
                </label>
                <blockquote style={{ flexDirection: "row", gap: "2rem" }}>
                  <mark>
                    <input
                      type="radio"
                      value="Paid"
                      name="ticketType"
                      checked={ticketData.ServiceDetails.ServiceType === "Paid"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setTicketData({
                            ...ticketData,
                            ServiceDetails: {
                              ...ticketData.ServiceDetails,
                              ServiceType: e.target.value,
                            },
                          });
                        }
                      }}
                      disabled={ticketData.IsQuotationSent}
                      required
                    />
                    <label>Paid</label>
                  </mark>
                  <mark>
                    <input
                      type="radio"
                      value="FOC"
                      name="ticketType"
                      checked={ticketData.ServiceDetails.ServiceType === "FOC"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setTicketData({
                            ...ticketData,
                            ServiceDetails: {
                              ...ticketData.ServiceDetails,
                              ServiceType: e.target.value,
                            },
                          });
                        }
                      }}
                      disabled={ticketData.IsQuotationSent}
                      required
                    />
                    <label>FOC (Free of Cost)</label>
                  </mark>
                </blockquote>
              </blockquote>
              {ticketData.ServiceDetails.ServiceType === "FOC" && (
                <blockquote>
                  <label>
                    Remarks{" "}
                    <sup>
                      <i
                        class="fa-solid fa-asterisk"
                        style={{ color: "red" }}
                      ></i>
                    </sup>
                  </label>
                  <textarea
                    value={ticketData.ServiceDetails.Remarks}
                    onChange={(e) =>
                      setTicketData({
                        ...ticketData,
                        ServiceDetails: {
                          ...ticketData.ServiceDetails,
                          Remarks: e.target.value,
                        },
                      })
                    }
                    rows={2}
                    onInput={(e) => {
                      e.target.value = e.target.value.slice(0, 300);
                    }}
                    placeholder="Enter Remarks (300 Characters Maximum)"
                  ></textarea>
                </blockquote>
              )}
              <blockquote>
                <label>
                  Due Date{" "}
                  <sup>
                    <i
                      class="fa-solid fa-asterisk"
                      style={{ color: "red" }}
                    ></i>
                  </sup>
                </label>
                <input
                  type="date"
                  value={ticketData.ServiceDetails.DueDate}
                  required
                  onChange={(e) => {
                    setTicketData({
                      ...ticketData,
                      ServiceDetails: {
                        ...ticketData.ServiceDetails,
                        DueDate: e.target.value,
                      },
                    });
                  }}
                  disabled={ticketData.IsQuotationSent}
                />
              </blockquote>
              <blockquote>
                <label>Service Description</label>
                <textarea
                  placeholder="Enter Service Description"
                  rows={5}
                  value={ticketData.ServiceDetails.ServiceDescription}
                  onChange={(e) =>
                    setTicketData({
                      ...ticketData,
                      ServiceDetails: {
                        ...ticketData.ServiceDetails,
                        ServiceDescription: e.target.value,
                      },
                    })
                  }
                  disabled={ticketData.IsQuotationSent}
                ></textarea>
              </blockquote>
              <blockquote>
                <label>
                  Status{" "}
                  <sup>
                    <i
                      class="fa-solid fa-asterisk"
                      style={{ color: "red" }}
                    ></i>
                  </sup>
                </label>
                <select
                  required
                  onChange={(e) =>
                    setTicketData({ ...ticketData, Status: e.target.value })
                  }
                  disabled={ticketData.IsOrderCreated === false}
                >
                  <option value="">Select Status</option>
                  {ticketsStatus.map((x) => (
                    <option
                      value={x.status}
                      selected={ticketData.Status === x.status}
                    >
                      {x.status}
                    </option>
                  ))}
                </select>
              </blockquote>
              {enquiry?.enquiryType === "Parts" && (
                <blockquote>
                  <a
                    href="#"
                    onClick={() => {
                      setShowTicketParts(true);
                    }}
                  >
                    Click Here To Manage Parts
                  </a>
                </blockquote>
              )}
              <blockquote>
                <label>Feedback</label>
                <textarea
                  placeholder="Enter Feedback (Maximum 400 Characters)"
                  rows={5}
                  value={ticketData.ServiceDetails.FeedBack}
                  onChange={(e) =>
                    setTicketData({
                      ...ticketData,
                      ServiceDetails: {
                        ...ticketData.ServiceDetails,
                        FeedBack: e.target.value,
                      },
                    })
                  }
                  disabled={ticketData.IsOrderCreated === false}
                ></textarea>
              </blockquote>
            </>
          )}
          {ticketData.IsOrderCreated && (
            <a
              href="#"
              onClick={() => {
                setShowAssignedUsers(true);
                setShowAssignedUsersEdit(true);
                setTicketId(ticketData.SeriesId);
              }}
            >
              Click Here to Manage Users for Ticket Access
            </a>
          )}
          <button type="submit">Update</button>
          <CloseForm close={setshowticketpopup} />
        </form>
      )}
      {showticketParts && (
        <TicketParts
          newEnquiryData={enquiry}
          partsTicketLoading={partsTicketLoading}
          partsTicketData={partsTicketData}
          collapseparts={collapseparts}
          setcollapseparts={setcollapseparts}
          extraParts={extraParts}
          extraPartsInput={extraPartsInput}
          setExtraPartsInput={setExtraPartsInput}
          setfilteredpartnames={setfilteredpartnames}
          extraPartsIndex={extraPartsIndex}
          filteredpartnames={filteredpartnames}
          setPartsTicketData={setPartsTicketData}
          setPartsTicketLoading={setPartsTicketLoading}
          setShowPartsTicketData={setShowTicketParts}
          setExtraParts={setExtraParts}
          setExtraPartsIndex={setExtraPartsIndex}
          setCreatePartsTicket={setCreatePartsTicket}
          createPartsTicket={createPartsTicket}
          partnames={partnames}
          setpartnames={setpartnames}
        />
      )}
    </section>
  );
}

export default TicketPopup;
